import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/switch-to-cellular.vue
var o = {
	name: "DtIconSwitchToCellular",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--switch-to-cellular"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Switch To Cellular",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M3.896.646a.5.5 0 0 1 .708 0l1.25 1.25a.5.5 0 0 1 0 .708l-1.25 1.25a.5.5 0 1 1-.708-.708l.397-.396H2.5a.5.5 0 0 1 0-1h1.793l-.397-.396a.5.5 0 0 1 0-.708ZM10.5 2.5a.5.5 0 0 1 .5.5v7.5a.5.5 0 0 1-1 0V3a.5.5 0 0 1 .5-.5Zm-7.896.646a.5.5 0 0 1 0 .708l-.397.396H4a.5.5 0 0 1 0 1H2.207l.397.396a.5.5 0 1 1-.708.708l-1.25-1.25a.5.5 0 0 1 0-.708l1.25-1.25a.5.5 0 0 1 .708 0ZM8 5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5A.5.5 0 0 1 8 5ZM3 9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 3 9Zm2.5-2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=switch-to-cellular.js.map